<template>
    <div >
        <Card>
            <Row>
                <Col span="6">
                    {{ paymentPending.bank_account.accountName }}
                    <br>
                    {{ paymentPending.transactionDate | dateFormatted }} - {{ paymentPending.createdby }} 
                </Col>
                <Col span="6"><h3>{{ paymentPending.amount | numberFormatted }} </h3></Col>
                <Col span="8">                   
                    <template v-if="!paymentPending.payment">
                        <router-link 
                            :key="$route.fullPath"
                            :to="{ 
                                    name: 'paymentAddPending', 
                                    params: { paymentPendingId : paymentPending.id } 
                                }">                                
                            <Button type="primary" size="small" >Create Payment</Button>
                        </router-link>

                        <router-link 
                            :key="$route.fullPath"
                            :to="{ 
                                    name: 'paymentPendingAssign', 
                                    params: { paymentPendingId : paymentPending.id } 
                                }">
                            <Button type="primary" size="small" >Assign Payment</Button>
                        </router-link>
                    </template>
                    <template v-else>
                        {{ paymentPending.payment.receivable.description }}
                        <br />
                        <hr style="width: 95%">
                        {{ paymentPending.payment.marking_header.markingheadercode }}
                        <br>
                        {{ paymentPending.payment.paymentDate }}
                        <br>
                        {{ paymentPending.payment.receivable.creditAmount | numberFormatted }}                        
                        <br>
                    </template>
                    <Button @click="updatePaymentPending" type="success" size="small">Edit</Button>
                    <Button @click="deletePaymentPending" type="error" size="small" v-if="!paymentPending.payment">Delete</Button>
                </Col>
            </Row>            
        </Card>
        <template>
            <Modal
                v-if="renderModal.updatePaymentPending"
                v-model="modal.updatePaymentPending"
                title="Edit Data">
                <Form>
                    <Form-item>
                        <Select v-model="formEdit.paymentPending.bankAccountId" 
                        placeholder="Pilih Bank"
                            
                            clearable >
                            <Option 
                                v-for="bankAccount in bankAccounts" 
                                :value="bankAccount.id" 
                                :key="bankAccount.id">{{ bankAccount.accountName }}</Option>
                        </Select>
                    </Form-item>
                    <Form-item>
                        <Date-picker 
                            v-model="formEdit.paymentPending.transactionDate" 
                            type="date" 
                            placeholder="Tanggal Transaksi" 
                            format="dd/MM/yyyy">
                        </Date-picker>
                    </Form-item>
                    <Form-item>
                        <i-input v-model="formEdit.paymentPending.amount" placeholder="Payment pending amount"></i-input>
                    </Form-item>
                </Form>
                <Alert v-if="paymentPending.payment">
                    <b>Payment</b>
                    <br>
                    <br>
                    Marking : {{ paymentPending.payment.marking_header.markingheadercode }}
                    <br>
                    Description : {{ paymentPending.payment.receivable.description }}
                    <br>
                    Payment Date : {{ paymentPending.payment.paymentDate }}
                    <br>
                    Amount : {{ paymentPending.payment.receivable.creditAmount | numberFormatted }}
                    <br>
                    <br>
                    <span style="color: red">Ketik "<b>{{ paymentPending.payment.marking_header.markingheadercode }}</b>" untuk unassign payment :</span>
                    <Form>
                        <Form-item>
                            <i-input v-model="confirmUnAssignedPaymentPending" placeholder="Hapus data"></i-input>
                        </Form-item>
                    </Form>
                    <Button 
                        v-show="true"
                        type="error" 
                        v-if="confirmUnAssignedPaymentPending == paymentPending.payment.marking_header.markingheadercode"
                        :loading="loading.unAssignedPaymentPending"
                        @click="unAssignedPaymentPending" >
                        <span v-if="!loading.unAssignedPaymentPending">Unassigned Payment</span>
                        <span v-else>Wait.....</span>                                 
                    </Button>                    
                </Alert>
                <div slot="footer">
                    <Button 
                        v-show="true"
                        type="primary" 
                        :loading="loading.updatePaymentPending"
                        @click="postUpdatePaymentPending" >
                        <span v-if="!loading.updatePaymentPending">Edit</span>
                        <span v-else>Wait.....</span>                                 
                    </Button>
                </div>                
            </Modal>
            <Modal
                v-if="renderModal.deletePaymentPending"
                v-model="modal.deletePaymentPending"
                title="Delete Data">
                <p>Anda yakin ingin menghapus data?</p>
                <div slot="footer">
                    <Button 
                        v-show="true"
                        type="error" 
                        :loading="loading.deletePaymentPending"
                        @click="postDeletePaymentPending" >
                        <span v-if="!loading.deletePaymentPending">Delete</span>
                        <span v-else>Wait.....</span>                                 
                    </Button>
                </div>                
            </Modal>
        </template>
    </div>
</template>

<script>
import { HTTP } from "@/components/http-lib";
import moment from 'moment'

export default {    
    props: {
        paymentPending: Object
    },
    data: () => ({
        renderModal: {
            updatePaymentPending: false,
            deletePaymentPending: false
        },
        modal: {
            updatePaymentPending: false,
            deletePaymentPending: false,
        },
        loading: {
            updatePaymentPending: false,
            deletePaymentPending: false,
            unAssignedPaymentPending: false            
        },
        bankAccounts: [],
        formEdit: {
            paymentPending: {
                id: '',
                amount: '',
                bankAccountId: '',
                transactionDate: ''
            }
        },
        confirmUnAssignedPaymentPending: '',
    }),  
    methods: {
        onSuccessUpload: function(response, file){
            this.$emit('on-success-upload', response)
        },
        updatePaymentPending: function() {
            this.assignFormEditValue();
            this.confirmUnAssignedPaymentPending = '';
            this.renderModal.updatePaymentPending = true;
            this.modal.updatePaymentPending = true;
        },
        assignFormEditValue: function() {
            let transactionDate = moment(this.paymentPending.transactionDate).format("DD/MM/YYYY");
            this.formEdit.paymentPending.transactionDate = transactionDate;
            this.formEdit.paymentPending.bankAccountId = this.paymentPending.bank_account.id;
            this.formEdit.paymentPending.amount = this.paymentPending.amount;            
            this.formEdit.paymentPending.id = this.paymentPending.id;
        },
        getBankAccount: function() {
            HTTP.get("bankAccount/findAll/active")
                .then(response => {
                this.bankAccounts = response.data;
                })
                .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
                });
        },
        postUpdatePaymentPending: async function() {
            this.loading.updatePaymentPending = true;
            let data = this.formEdit.paymentPending;
            data.transactionDate = moment(this.formEdit.paymentPending.transactionDate, "DD/MM/YYYY").format("YYYY-MM-DD");
            HTTP.post("paymentPending/update", data)
                .then(response => {
                    this.$Message.success('Data Updated!');
                    this.loading.updatePaymentPending = false;
                    this.modal.updatePaymentPending = false;
                    this.reloadParent();
                })
                .catch(e => {
                    this.$Message.error('Update Failed!');
                    this.loading.updatePaymentPending = false;
                    this.modal.updatePaymentPending = false;
                });
        },
        deletePaymentPending: function() {
            this.renderModal.deletePaymentPending = true;
            this.modal.deletePaymentPending = true;
        },
        postDeletePaymentPending: function() {
            this.loading.deletePaymentPending = true;
            HTTP.delete("paymentPending/" + this.paymentPending.id)
                .then(response => {
                    this.$Message.success('Data Deleted!');
                    this.loading.deletePaymentPending = false;
                    this.modal.deletePaymentPending = false;
                    this.reloadParent();
                })
                .catch(e => {
                    this.$Message.error('Delete Failed!');
                    this.loading.deletePaymentPending = false;
                    this.modal.deletePaymentPending = false;
                });            
        },
        reloadParent: function() {
            setTimeout(() => this.$emit("reloadParent"), 100);
        },
        unAssignedPaymentPending: function() {
            this.loading.unAssignedPaymentPending = true;
            HTTP.get("paymentPending/unAssignedPayment/id/" + this.paymentPending.id)
                .then(response => {
                    let dataLog = {
                        'paymentPendingId': this.paymentPending.id,
                        'paymentId': this.paymentPending.payment.id
                    };
                    HTTP.post("paymentPending/unAssignedPayment/log", dataLog)
                        .then(response => {
                            this.$Message.success('Data Deleted!');
                            this.loading.unAssignedPaymentPending = false;
                            this.modal.updatePaymentPending = false;
                            this.reloadParent();
                        })
                        .catch(e => {
                            this.$Message.error('Insert Log Failed!');
                            this.loading.unAssignedPaymentPending = false;
                            this.modal.updatePaymentPending = false;
                        });            
                })
                .catch(e => {
                    this.$Message.error('Delete Failed!');
                    this.loading.unAssignedPaymentPending = false;
                    this.modal.updatePaymentPending = false;
                });            
        }
    },

  watch: {},

  created() {
      this.getBankAccount();
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// PaymentPendingRow.vue?73e8213e